import type { RouteLocationNormalized, Router } from "vue-router";

export const employeeRouteName = {
  index: "employees.index",
  detail: "employees.detail",
};

export const employeeRoute = [
  {
    path: "/employees",
    name: employeeRouteName.index,
    component: () => import("../pages/DataTablePage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "employee",
      breadcrumbs: () => [{ title: "Employee" }],
    },
  },
  {
    path: "/employees/:id",
    name: employeeRouteName.detail,
    component: () => import("../pages/DetailPage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "employee",
      breadcrumbs: (_to: RouteLocationNormalized, router: Router) => [{ path: router.resolve({ name: employeeRouteName.index }).path, title: "Employee" }, { title: "Detail" }],
    },
  },
];
